import OapFindation from './code/Scripts/components/OapFindation.vue';

export default {
  components: {
    OapFindation,
  },
};
